import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {AdminEntityService} from "./AdminEntityService";
import {ListUsersRequest, User} from "../../../generated/protocol";
import {injectable} from "inversify";

export const ITEM_PLAYERS_SERVICE_NAME = "itemPlayersService";

export interface ItemPlayersService extends AdminEntityService<ListUsersRequest> {
}

@injectable()
export class ItemPlayersServiceImpl extends AbstractAdminEntityService<User, ListUsersRequest> {
    constructor() {
        super("/item/players");
    }
}


// WEBPACK FOOTER //
// ./src/app/service/admin/ItemPlayersService.ts